/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Typography2, useTheme } from '@coursera/cds-core';

import ExternalLinksWrapper from 'bundles/assess-common/components/ExternalLinksWrapper';
import type { FileUploadSubmissionPartResponse } from 'bundles/compound-assessments/components/api/types/CompoundAssessmentsForm';
import EmbeddedContent from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedContent';

import _t from 'i18n!nls/compound-assessments';

const styles = {
  noFileMessage: (theme: Theme) => css({ color: 'var(--cds-color-grey-600)' }),
};

type Props = {
  submissionPart: FileUploadSubmissionPartResponse;
  renderFileUploadForPreview?: boolean;
};

export const FileUploadView: React.FC<Props> = (props: Props) => {
  const { submissionPart, renderFileUploadForPreview } = props;
  const text = submissionPart.title || submissionPart.fileUrl.split('/').pop() || '';
  const theme = useTheme();
  return (
    <ExternalLinksWrapper>
      <Typography2 component="p" variant="bodyPrimary">
        {submissionPart.title}
      </Typography2>
      {submissionPart.fileUrl ? (
        <EmbeddedContent
          url={submissionPart.fileUrl}
          title={text}
          renderFileUploadForPreview={renderFileUploadForPreview}
        />
      ) : (
        <Typography2 component="p" variant="bodyPrimary" css={styles.noFileMessage(theme)}>
          {_t('No uploaded file')}
        </Typography2>
      )}
      <Typography2 component="p" variant="bodySecondary">
        {submissionPart.caption}
      </Typography2>
    </ExternalLinksWrapper>
  );
};

export default FileUploadView;
